import { createSelector } from '@ngrx/store'

export const getSmtpSettingsState = createSelector(
  (state: any) => state.smtpSettings,
  (state: any) => state,
)
